import { apiGet, apiPatch, apiPost } from './api'
import { NUDGE_QUEUE, NUDGE_QUEUE_DETAIL, NUDGE_QUEUE_NO_SHOW, ADMIN_NUDGE_METRICS, ADMIN_NUDGE_QUEUE, ADMIN_AI_OBSERVABILITY, ADMIN_SCHEDULER_SLOTS, ADMIN_SCHEDULER_SLOT, DEV_TRIGGER_SCANNER } from './endpoints'
import type { NudgeQueueSummary, NudgeQueueDetail, NudgeMetrics, AdminQueueRow, AiObservability, PaginatedResponse, SchedulerSlot } from '../types/api'

type NudgeQueueFilters = {
  status?: string
}

export function fetchNudgeQueue(
  page = 0,
  size = 20,
  filters?: NudgeQueueFilters,
): Promise<PaginatedResponse<NudgeQueueSummary>> {
  const params = new URLSearchParams({ page: String(page), size: String(size) })
  if (filters?.status) params.set('status', filters.status)
  return apiGet<PaginatedResponse<NudgeQueueSummary>>(`${NUDGE_QUEUE}?${params.toString()}`)
}

export function fetchNudgeQueueDetail(id: string): Promise<NudgeQueueDetail> {
  return apiGet<NudgeQueueDetail>(NUDGE_QUEUE_DETAIL(id))
}

export function fetchNudgeMetrics(): Promise<NudgeMetrics> {
  return apiGet<NudgeMetrics>(ADMIN_NUDGE_METRICS)
}

export function fetchAiObservability(): Promise<AiObservability> {
  return apiGet<AiObservability>(ADMIN_AI_OBSERVABILITY)
}

export function fetchAdminQueueRows(params: {
  page: number
  size: number
  status?: string
  businessId?: string
  q?: string
  sinceHours?: number
}): Promise<PaginatedResponse<AdminQueueRow>> {
  const qs = new URLSearchParams({ page: String(params.page), size: String(params.size) })
  if (params.status)     qs.set('status', params.status)
  if (params.businessId) qs.set('businessId', params.businessId)
  if (params.q)          qs.set('q', params.q)
  if (params.sinceHours) qs.set('sinceHours', String(params.sinceHours))
  return apiGet<PaginatedResponse<AdminQueueRow>>(`${ADMIN_NUDGE_QUEUE}?${qs.toString()}`)
}

export function fetchAdminSchedulerSlots(): Promise<SchedulerSlot[]> {
  return apiGet<SchedulerSlot[]>(ADMIN_SCHEDULER_SLOTS)
}

export function triggerDevScanner(): Promise<{ inserted: number }> {
  return apiPost<{ inserted: number }, Record<string, never>>(DEV_TRIGGER_SCANNER, {})
}

export function markNoShow(id: string): Promise<void> {
  return apiPost<void, Record<string, never>>(NUDGE_QUEUE_NO_SHOW(id), {})
}

export function patchAdminSchedulerSlot(
  slotId: string,
  patch: { fireTimeLocal?: string; active?: boolean },
): Promise<SchedulerSlot> {
  return apiPatch<SchedulerSlot, { fireTimeLocal?: string; active?: boolean }>(
    ADMIN_SCHEDULER_SLOT(slotId),
    patch,
  )
}
